/**
 * Le domaine « Média interne » n'est qu'une source de contenus mutualisés,
 * administrée depuis l'espace « Équipe interne » de l'admin. Il ne doit pas
 * être proposé comme domaine d'usage dans l'application.
 */
export const MEDIA_INTERNAL_DOMAIN_UUID = '2bc5decc-cd2e-46ad-92d7-f17234fdeebd';

/**
 * Domaine historique « NosDroits » (V1), désactivé : les community managers y
 * sont encore rattachés d'office, mais il n'a rien à proposer dans l'application.
 */
export const NOSDROITS_DOMAIN_UUID = '792a622b-fa4c-44c7-92fa-b1b0fd37336a';

const HIDDEN_DOMAIN_UUIDS = [MEDIA_INTERNAL_DOMAIN_UUID, NOSDROITS_DOMAIN_UUID];

export const filterSelectableDomains = <T extends { uuid?: string }>(
  domains: T[]
): T[] => {
  if (!Array.isArray(domains)) {
    return domains;
  }

  const selectable = domains.filter(
    (domain: T) => !HIDDEN_DOMAIN_UUIDS.includes(domain?.uuid)
  );

  // Garde-fou : ne jamais laisser un utilisateur sans aucun domaine.
  return selectable.length ? selectable : domains;
};
